import configureStore from './redux/configure-store';
export var createStore = configureStore;
